import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const K: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.K');

    return (
        <section
            id="rapid-mag-K"
            className={`rapid-mag-K ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-K'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1763001562465/20251113-103628.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1763001562465/20251113-103628.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1763001562718/20251113-103643.jpg"
                    />
                </div>
            </div>
        </section>
    );
};
export default K;
